module.exports = __webpack_public_path__ + "static/biwee-ISV-trailer-180bdcb43a6b27f6341f5f0fec94e73f.mp4";